import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F6252Service {

  constructor(private http: HttpClient) { }

  /**
   * Fetch Form 6252 Details
   * Action code: 'de0fhr'
   */
  fetchF6252Details(
    rowData: any,
    sso_id: string,
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    let jcd_key = 0;
    if (rowData.JCD_KEY == undefined) {
      jcd_key = 250;
    } else {
      jcd_key = rowData.JCD_KEY;
    }
    
    const specificParams: any = {
      action_code: 'de0fhr',
      sso_id: sso_id,
      tax_year: rowData.TAX_YEAR,
      scenario: rowData.SCENARIO,
      jcd_key: jcd_key,
      combination_key: rowData.COMBINATION_KEY,
      jcd_ta_key: null
    };
    
    // Merge params exactly like JsonObjectFactory.getJSONObj
    let params = _.merge({}, globalService?.globalParams || {}, filterParams, specificParams);
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/loadJsonObject`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }

  /**
   * Fetch List of Values (LOV)
   * Action code: 'sjh60s'
   */
  fetchLOV(
    baseUrl: string,
    specificParams: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    // Merge params exactly like JsonObjectFactory.getJSONObj
    let params = _.merge({}, globalService?.globalParams || {}, filterParams, specificParams);
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/loadJsonObject`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }

  /**
   * Fetch Modal Calculation Data
   * Action code: '1ubsuu'
   */
  fetchModalCalcData(
    baseUrl: string,
    specificParams: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    // Merge params exactly like JsonObjectFactory.getJSONObj
    let params = _.merge({}, globalService?.globalParams || {}, filterParams, specificParams);
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/loadJsonObject`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }

  /**
   * Save Form 6252 Data
   * Action code: 'wjvmhl'
   * Process name: 'form-6252-save'
   */
  saveForm6252(
    baseUrl: string,
    final_data: any[],
    clob_settings: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Build payload EXACTLY like original AngularJS
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);

    // Essential parameters with fallbacks
    params.json_data = JSON.stringify(final_data);
    params.json_settings = JSON.stringify(clob_settings);
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || 250;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.process_name = "form-6252-save";

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/saveJsonObject?action_code=wjvmhl`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }
}

